import React, {Component} from 'react';
import {connect} from "react-redux";
import {Route} from 'react-router';
import Register from "./containers/Register/Register.container";
import Waiting from './containers/Waiting/Waiting.container'
import Accepted from './containers/Accepted/Accepted.container'
import Summary from "./containers/Summary/Summary";
import Recheck from "./containers/Recheck/Recheck";
import FirstPage from "./containers/FirstPage/FirstPage.container";
import Error from "./containers/Error/error";
import NotFound from "./containers/NotFound/notFound";
import i18n from "i18next";
import Preloader from "./containers/atoms/spinner/preloader";
import {history, pages} from "./configureHistory";
class App extends Component<any> {
    private currentPathname: string;
    private currentSearch: string;
    private currentLanguage: string;
    constructor(props: any) {
        super(props);
        this.currentPathname = "";
        this.currentSearch = "";
        this.currentLanguage = "";
    }

    //Re-initialising i18n on every render re-emits languageChanged in a loop, so only
    //do it when the configured language actually changes, and never during render.
    applyLanguage(): void {
        const lng = this.props.styles.CommonSettings.DefaultLanguage;
        if(lng && lng !== this.currentLanguage) {
            this.currentLanguage = lng;
            i18n.init({lng});
        }
    }

    componentDidUpdate(): void {
        this.applyLanguage();
    }

    componentDidMount(): void {
        this.applyLanguage();
        history.listen((newLocation,action) => {
            const currentPath = history.location.pathname;
            if (pages.indexOf(currentPath.replace('/','')) > -1) {
                // @ts-ignore
                if(history.state) {
                    // @ts-ignore
                    sessionStorage.setItem('reqID', history.state.state.data.LinkCode);
                }

            }
            if(history.action === 'POP'){
                console.log("back clicked");
                history.goForward();
            }
        });
    }


    showFlags = ()=>{
        if(this.props.styles.CommonSettings.DefaultLanguage != null || this.props.styles.CommonSettings.SecondaryLanguage != "")
        {
            return true;
        }
    };

    showLogo = ()=>{
        const logoStyles = {
            height: '45px',
            maxHeight: '45px',
            width: 'auto'
        };
        if(this.props.styles.CommonSettings.Logo.length>0)
            return <img style={logoStyles} src={String(this.props.styles.CommonSettings.Logo)} />;
        return <div></div>;
    };

    render() {

        const style = {
            backgroundColor:this.props.styles.CommonSettings.HeaderBackgroundColor,
            display: "flex",
            justifyContent: "space-between",
            height: '50px',
            color:this.props.styles.CommonSettings.FontColor,
            padding: '0 10px',
            alignItems: 'center'
        } as React.CSSProperties;
        const flagsWrapper = {
            display: 'flex',
            alignItems: 'center'
        };

        //TODO ADD from commonSettings
        const dFlag = "flag-icon-"+this.props.styles.CommonSettings.DefaultLanguage;
        const sLang = "flag-icon-"+this.props.styles.CommonSettings.SecondaryLanguage;
        document.body.style.backgroundColor = this.props.styles.CommonSettings.BackgroundColor;
        return (
            <div>
                {this.props.showPreloader && <Preloader/>}

                <div className="header" style={style}>

                    {this.showLogo()}
                    {this.showFlags() && <div style={flagsWrapper}>
                        <div className={dFlag} onClick={()=>{i18n.init({lng:this.props.styles.CommonSettings.DefaultLanguage})}} />
                        <div className={sLang} onClick={()=>{i18n.init({lng:this.props.styles.CommonSettings.SecondaryLanguage})}} />
                    </div>}
                </div>

            <Route path="/:code/:domainId?/:pageType?/:storeId?" component={FirstPage}/>
            <Route exact path="/register" component={Register}/>
            <Route exact path="/waiting" component={Waiting}/>
            <Route exact path="/accepted" component={Accepted}/>
            <Route exact path="/summary" component={Summary}/>
            <Route exact path="/recheck" component={Recheck}/>
            <Route exact path="/error" component={Error}/>
            <Route exact path="/notFound" component={NotFound}/>
        </div>
        )
    }
}

const mapStateToProps = (state:any) => {
    return {
        showPreloader: state.globalReducer.loading,
        styles : state.globalReducer.styles
    };
};

export default connect(
    mapStateToProps,
    null
    // mapDispatchToProps
)(App);
